// extracted by mini-css-extract-plugin
export default {"container":"portfolioDisplay_container__87Bdn","projectDirectory":"portfolioDisplay_projectDirectory__1vaOb","projectsTitle":"portfolioDisplay_projectsTitle__3acAX"};